;(function (angular, _) {
  'use strict'

  class ElementDatePickerController {
    enabled
    setDate () {
      if (this.enabled) {
        this.set()
      }
    }

    resetDate () {
      if (this.enabled) {
        this.reset()
      }
    }
  }

  angular.module('kilo.common.components')
    .component('elementDatePicker', {
      bindings: {
        value: '<',
        required: '<',
        enabled: '<',
        placeholder: '<',
        set: '&',
        reset: '&',
        name: '@'
      },
      controller: ElementDatePickerController,
      templateUrl: '/app/common/components/element-date-picker/element-date-picker.template.html'
    })
})(window.angular, window._)
